// Per-TAB ownership marker for an in-progress assessment attempt.
//
// The backend enforces a single active attempt: once an assessment is started
// (status PENDING -> INPROGRESS) any other start is rejected with 409, and
// resume is allowed ONLY for diagnosis assessments that present this marker.
//
// Storage is `sessionStorage` ON PURPOSE — it is scoped to a single browser
// tab/window:
//   - it SURVIVES a refresh / reload and tab-switch within the same tab, so a
//     diagnosis attempt can be resumed by the tab that started it; but
//   - it is NOT shared with other tabs, other windows, or other devices, so a
//     second tab / window / device has no marker -> it cannot resume and is
//     blocked. (localStorage would be shared across tabs of the same browser,
//     which let a second tab wrongly "resume" a diagnosis.)
//
// This is not a security boundary (the server's atomic claim is). It only marks
// "the tab that started this attempt" for resume/visibility.

const KEY_PREFIX = 'pl_assessment_inprogress_'

const keyFor = assessmentAssignedId => `${KEY_PREFIX}${assessmentAssignedId}`

export const markAssessmentStarted = assessmentAssignedId => {
  if (!assessmentAssignedId) {
    return
  }
  try {
    sessionStorage.setItem(keyFor(assessmentAssignedId), '1')
  } catch (_) {
    // Storage can be unavailable (private mode / quota); resume just won't work.
  }
}

export const hasAssessmentMarker = assessmentAssignedId => {
  if (!assessmentAssignedId) {
    return false
  }
  try {
    return sessionStorage.getItem(keyFor(assessmentAssignedId)) === '1'
  } catch (_) {
    return false
  }
}

export const clearAssessmentMarker = assessmentAssignedId => {
  if (!assessmentAssignedId) {
    return
  }
  try {
    sessionStorage.removeItem(keyFor(assessmentAssignedId))
  } catch (_) {
    // Ignore — a stale marker is harmless (the server still gates the attempt).
  }
}
